import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ThemeService } from "@app/services/theme.service";
import { IRootScope } from "@models";

@NgFilter({
    token: Token.ThemeColorFilter,
    dependencies: [
        Token.ThemeService,
        Token.$RootScope
    ]
})
export class ThemeColorFilter {
    constructor(themeService: ThemeService, $rootScope: IRootScope) {
        return ((palette: string, shadeEnumValue: string, opacity: number, contrast: boolean) => {
            let shadeNum: number = 50;
            if (shadeEnumValue.startsWith("lighter")) {
                shadeNum = Number(shadeEnumValue.substr(7)) * 10;
            } else if (shadeEnumValue.startsWith("darker")) {
                shadeNum = (Number(shadeEnumValue.substr(6)) * 10) + 50;
            }

            if (palette == "warning") {
                palette = "warn";
            }
            return themeService.getRgbString(themeService.getActiveTheme(), palette, shadeNum, opacity, contrast, false);
        }) as any;
    }
}
